export var LineItemPricingTypeEnumDTO = /*#__PURE__*/ function(LineItemPricingTypeEnumDTO) {
    LineItemPricingTypeEnumDTO["Fixed"] = "fixed";
    LineItemPricingTypeEnumDTO["Variable"] = "variable";
    return LineItemPricingTypeEnumDTO;
}({});
export var LineItemOriginTypesEnumDTO = /*#__PURE__*/ function(LineItemOriginTypesEnumDTO) {
    LineItemOriginTypesEnumDTO["Service"] = "service";
    LineItemOriginTypesEnumDTO["AdHocCharge"] = "adHocCharge";
    return LineItemOriginTypesEnumDTO;
}({});
export var LineItemSubItemOriginTypesEnumDTO = /*#__PURE__*/ function(LineItemSubItemOriginTypesEnumDTO) {
    LineItemSubItemOriginTypesEnumDTO["ServiceBundle"] = "serviceBundle";
    return LineItemSubItemOriginTypesEnumDTO;
}({});
export var LineItemSubItemDiscountTypesDTO = /*#__PURE__*/ function(LineItemSubItemDiscountTypesDTO) {
    LineItemSubItemDiscountTypesDTO["Percent"] = "percent";
    LineItemSubItemDiscountTypesDTO["None"] = "none";
    return LineItemSubItemDiscountTypesDTO;
}({});
export var LineItemPeriodTypesDTO = /*#__PURE__*/ function(LineItemPeriodTypesDTO) {
    LineItemPeriodTypesDTO["FullTerm"] = "fullTerm";
    LineItemPeriodTypesDTO["PartialTerm"] = "partialTerm";
    LineItemPeriodTypesDTO["Delivery"] = "delivery";
    return LineItemPeriodTypesDTO;
}({});
export var InvoiceStatusTypesDTO = /*#__PURE__*/ function(InvoiceStatusTypesDTO) {
    InvoiceStatusTypesDTO["Pending"] = "pending";
    InvoiceStatusTypesDTO["ProcessingCharge"] = "processingCharge";
    InvoiceStatusTypesDTO["PaymentActionRequired"] = "paymentActionRequired";
    InvoiceStatusTypesDTO["RequiresPaymentApproval"] = "requiresPaymentApproval";
    InvoiceStatusTypesDTO["PaymentConfirmed"] = "paymentConfirmed";
    InvoiceStatusTypesDTO["PaymentFailed"] = "paymentFailed";
    InvoiceStatusTypesDTO["Paid"] = "paid";
    InvoiceStatusTypesDTO["PaidExternally"] = "paidExternally";
    InvoiceStatusTypesDTO["Voided"] = "voided";
    InvoiceStatusTypesDTO["Refunded"] = "refunded";
    InvoiceStatusTypesDTO["RefundFailed"] = "refundFailed";
    InvoiceStatusTypesDTO["PaymentStopped"] = "paymentStopped";
    InvoiceStatusTypesDTO["PaymentDisputed"] = "paymentDisputed";
    InvoiceStatusTypesDTO["PaymentDisputeWon"] = "paymentDisputeWon";
    InvoiceStatusTypesDTO["PaymentLateReturned"] = "paymentLateReturned";
    return InvoiceStatusTypesDTO;
}({});
export var InvoiceProcessingActionTypeEnum = /*#__PURE__*/ function(InvoiceProcessingActionTypeEnum) {
    InvoiceProcessingActionTypeEnum["UseStripeSDK"] = "useStripeSdk";
    InvoiceProcessingActionTypeEnum["RedirectToURL"] = "redirectToUrl";
    return InvoiceProcessingActionTypeEnum;
}({});
export var FailureCodeEnum = /*#__PURE__*/ function(FailureCodeEnum) {
    FailureCodeEnum["InvalidCardDeclinedDoNotHonor"] = "invalid_card_declined_do_not_honor";
    FailureCodeEnum["CardDeclinedInvalidAccount"] = "card_declined_invalid_account";
    FailureCodeEnum["DebitNotAuthorized"] = "debit_not_authorized";
    FailureCodeEnum["InsufficientFunds"] = "insufficient_funds";
    FailureCodeEnum["AccountClosed"] = "account_closed";
    FailureCodeEnum["AccountFrozen"] = "account_frozen";
    FailureCodeEnum["CouldNotProcessChargeExceedsAchWeeklyLimit"] = "could_not_process_charge_exceeds_ach_weekly_limit";
    FailureCodeEnum["CouldNotProcessChargeUndeliverablePayout"] = "could_not_process_charge_undeliverable_payouts";
    FailureCodeEnum["ExpiredCard"] = "expired_card";
    FailureCodeEnum["CardDeclinedInsufficientFunds"] = "card_declined_insufficient_funds";
    FailureCodeEnum["CardDeclinedHighRisk"] = "card_declined_risk_high";
    FailureCodeEnum["CardDeclinedLostCard"] = "card_declined_lost_card";
    FailureCodeEnum["CardDeclinedPickupCard"] = "card_declined_pickup_card";
    FailureCodeEnum["CardDeclinedIncorrectCvc"] = "card_declined_incorrect_cvc";
    FailureCodeEnum["CardDeclinedDoNotRetry"] = "card_previously_declined_do_not_retry";
    FailureCodeEnum["DisputedPayment"] = "disputed";
    FailureCodeEnum["BankAccountNotFound"] = "bank_account_not_found";
    FailureCodeEnum["CardDeclinedTransactionNotAllowed"] = "card_declined_transaction_not_allowed";
    FailureCodeEnum["CardDeclinedIncorrectNumber"] = "card_declined_incorrect_number";
    FailureCodeEnum["CardDeclinedTryAgainLater"] = "card_declined_try_again_later";
    FailureCodeEnum["CardDeclinedNotSupported"] = "card_declined_not_supported";
    FailureCodeEnum["Unknown"] = "unknown";
    FailureCodeEnum["InvalidAccountNumber"] = "invalid_account_number";
    FailureCodeEnum["BankAccountRestricted"] = "bank_account_restricted";
    FailureCodeEnum["BankAccountBlocked"] = "bank_account_blocked";
    FailureCodeEnum["MandateInvalid"] = "mandate_invalid";
    FailureCodeEnum["AmountTooSmall"] = "amount_too_small";
    FailureCodeEnum["PaymentIntentAuthenticationFailure"] = "payment_intent_authentication_failure";
    FailureCodeEnum["CardVelocityExceeded"] = "card_velocity_exceeded";
    FailureCodeEnum["DisputeDebitNotAuthorized"] = "disputed_debit_not_authorized";
    FailureCodeEnum["DisputeFraudulent"] = "disputed_fraudulent";
    FailureCodeEnum["DisputeCreditNotProcessed"] = "disputed_credit_not_processed";
    FailureCodeEnum["DisputeDuplicate"] = "disputed_duplicate";
    FailureCodeEnum["DisputeSubscriptionCanceled"] = "disputed_subscription_canceled";
    FailureCodeEnum["DisputeBankCannotProcess"] = "disputed_bank_cannot_process";
    FailureCodeEnum["DisputeCheckReturned"] = "disputed_check_returned";
    FailureCodeEnum["DisputeProductUnacceptable"] = "disputed_product_unacceptable";
    // refund failures
    FailureCodeEnum["RefundUnknown"] = "refund_unknown";
    FailureCodeEnum["RefundChargeNotRefundable"] = "refund_charge_not_refundable";
    FailureCodeEnum["RefundAccountClosed"] = "refund_account_closed";
    FailureCodeEnum["RefundInvalidAccountNumber"] = "refund_invalid_account_number";
    FailureCodeEnum["RefundPaymentStopped"] = "refund_payment_stopped";
    FailureCodeEnum["DisputeProductNotReceived"] = "disputed_product_not_received";
    FailureCodeEnum["GenericDecline"] = "generic_decline";
    FailureCodeEnum["PreviouslyDeclinedDoNotRetry"] = "previously_declined_do_not_retry";
    return FailureCodeEnum;
}({});
export var PaymentApprovalRecordTypesDTO = /*#__PURE__*/ function(PaymentApprovalRecordTypesDTO) {
    PaymentApprovalRecordTypesDTO["NoApprovalNecessary"] = "noApprovalNecessary";
    PaymentApprovalRecordTypesDTO["RequiresApproval"] = "requiresApproval";
    PaymentApprovalRecordTypesDTO["Approved"] = "approved";
    return PaymentApprovalRecordTypesDTO;
}({});
